import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock job logs — shown on the job logs & proof stage. */
const JobLogScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/JobLogs.PNG" alt="CleanDock job logs" />
)

export default JobLogScreen
